import "../style/page/cashback.scss";
import { useEffect, useState, useMemo } from "react";
import { diagnosticsdetails, diagnosticsorder, product_return } from "../../text/apidata";
import axios from "axios";
import { DateRangePicker } from "rsuite";
import subDays from "date-fns/subDays";
import startOfWeek from "date-fns/startOfWeek";
import endOfWeek from "date-fns/endOfWeek";
import addDays from "date-fns/addDays";
import "rsuite/dist/rsuite.css";
import isAfter from "date-fns/isAfter";
import BasicTable from "../maincomponent/reacttable/table";
import { Tooltip as ReactTooltip } from "react-tooltip";
import noimage from "../../assets/images/noimage.png";
import { sidebar } from "../redux/reducer/counterslice";
import { useDispatch, useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import Swal from "sweetalert2";
import copy from "copy-to-clipboard";
import { toast } from "react-toastify";

export default function DiagnosticsRecords(props) {
    const sideactive = useSelector((state) => state.counter.sidebarnav);
    const [tableheaderdata, settableheaderdata] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [dtpageindex, setdtPageindex] = useState(1);
    const [dtpagesize, setdtPagesize] = useState(10);
    const [datacount, setdatacount] = useState();
    const [data, setdata] = useState([]);
    const dispatch = useDispatch();
    const [doctorcount, setdoctorcount] = useState(0);
    const [appoinmentcount, setappoinmentcount] = useState(0);
    const [gender, setgender] = useState("all");
    const locationid = useSelector((state) => state.counter.loginuser_location_id)
    const [branches, setbranches] = useState(locationid != "all" ? locationid : "91");
    const [ageit, setageit] = useState("0");
    const [agegt, setagegt] = useState("120");
    const [datadownloadstate, setdatadownload] = useState("False")
    let roledata = localStorage.getItem("role");
    const [id, setid] = useState();

    var today = new Date();
    var priorDate = new Date(new Date().setDate(today.getDate() - 30));
    var it = convert(today);
    var gt = convert(priorDate);
    // console.log(it, gt);
    const [range, setrange] = useState([it, it]);
    // console.log(range, dcount, "777777");
    useEffect(() => {
        props.loaderchange("true");
        axios({
            method: "get",
            url: diagnosticsdetails,
            headers: {
                Authorization: "Bearer " + localStorage.getItem("token") + "",
            },
            params: {
                date_gt: range[0],
                date_lt: range[1],
                page: dtpageindex,
                page_size: dtpagesize,
                package_name: searchQuery,
                gender: gender,
                location: branches,
                age_lt: ageit != "" ? ageit : "0",
                age_gt: agegt != "" ? agegt : "120",
                generate_excel: datadownloadstate,
                order_status: 'Samples Collected'
            },
        })
            .then((res) => {
                console.log(res.data.data);
                setdata(res.data.data);
                if (res.data.data.data != undefined) {
                    settableheaderdata(res.data.data.data);
                } else {
                    window.open(res.data.data)
                }
                setdatadownload("False")
                setdatacount(res.data.data_count);
                setdoctorcount(
                    "₹" +
                    parseFloat(res.data.data.amount_paid)
                        .toFixed(0)
                        .replace(/(\d)(?=(\d\d)+\d$)/g, "$1,")
                );
                setappoinmentcount(res.data.data.appointment_count);

                props.loaderchange("false");
            })
            .catch((error) => {
                console.log(error);
                props.loaderchange("false");
                // setdtPageindex(dtpageindex-1)
                props.popupalert("true");
                props.popuptext("No Data Available");
                setTimeout(() => {
                    props.popupalert("false");
                }, 2000);
            });
    }, [range, dtpageindex, dtpagesize, searchQuery,
        gender,
        branches,
        ageit,
        agegt,
        datadownloadstate

    ]);

    function convert(str) {
        var date = new Date(str),
            mnth = ("0" + (date.getMonth() + 1)).slice(-2),
            day = ("0" + date.getDate()).slice(-2);
        return [date.getFullYear(), mnth, day].join("-");
    }

    const handlechangedate = (name, value) => {
        // let data =value.slice(0, 10)
        if (value != null) {
            setrange((oldArray) => [...oldArray, value.slice(0, 10)]);
        }
    };
    const cleaningrange = () => {
        //setrange([gt,it]);
    };

    const deleteappoinment = (e, ele) => {
        setid(e);
        console.log(ele,)
        console.log(ele.id
            , ele.return_amount
            , ele.patient.id, "ahahhj")
        const swalWithBootstrapButtons = Swal.mixin({
            customClass: {
                confirmButton: "btn btn-primary",
                cancelButton: "btn btn-info "
            },
            buttonsStyling: false
        });
        swalWithBootstrapButtons.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Fully Return",
            cancelButtonText: "Partial Return",
            reverseButtons: true,
            showLoaderOnConfirm: true,

        }).then((result) => {
            if (result.isConfirmed || result.dismiss === "cancel") {
                Swal.fire({
                    title: "Enter Amount",
                    input: "number",
                    inputValue: ele.return_amount,
                    inputAttributes: {
                        autocapitalize: "off",
                        required: "true"
                    },
                    showCancelButton: true,
                    confirmButtonText: "Sumbit",
                    showLoaderOnConfirm: true,
                    // preConfirm: async (login) => {
                    // },
                    allowOutsideClick: true
                }).then((result) => {
                    if (result.isConfirmed) {
                        if (result.value) {
                            var data1 = {
                                type: "orderdiagnostics",
                                r_totalamount: Number(result.value.amount),
                                order_id: ele.id,
                                patient_id: ele?.patient?.id
                            }
                            console.log(data1)
                            axios({
                                url: product_return,
                                method: "post",
                                data: data1,
                                headers: {
                                    Authorization: "Bearer " + localStorage.getItem("token") + "",
                                },
                            }).then((Response) => {
                                Swal.fire({
                                    title: "Good job!",
                                    text: "Amount Added Successfully!",
                                    icon: "success"
                                });
                            }).catch((error) => {

                            })
                        } else {
                            Swal.fire({
                                icon: "error",
                                title: "Oops...",
                                text: "Please enter a value!",
                            });
                        }
                    }
                });
            }
        });
    };

    const predefinedBottomRanges = [
        {
            label: "Today",
            value: [new Date(), new Date()],
            placement: "left",
        },
        {
            label: "Yesterday",
            value: [addDays(new Date(), -1), addDays(new Date(), -1)],
            placement: "left",
        },
        {
            label: "This week",
            value: [startOfWeek(new Date()), endOfWeek(new Date())],
            placement: "left",
        },
        {
            label: "Last 30 days",
            value: [subDays(new Date(), 29), new Date()],
            placement: "left",
        },

        {
            label: "Last week",
            closeOverlay: false,
            value: (value, index) => {
                const [start = new Date()] = value[index] || [];
                return [
                    addDays(startOfWeek(start, { weekStartsOn: 0 }), -7),
                    addDays(endOfWeek(start, { weekStartsOn: 0 }), -7),
                ];
            },
            appearance: "default",
        },
        {
            label: "Next week",
            closeOverlay: false,
            value: (value, index) => {
                // console.log(value);
                const [start = new Date()] = value[index] || [];
                return [
                    addDays(startOfWeek(start, { weekStartsOn: 0 }), 7),
                    addDays(endOfWeek(start, { weekStartsOn: 0 }), 7),
                ];
            },
            appearance: "default",
        },
    ];
    const columns = useMemo(
        () => [
            {
                Header: "Bill Id",
                accessor: "",

                Cell: (row) => {
                    return (
                        <>
                            <p
                                data-tooltip-id="my-tooltip"
                                data-tooltip-content={row.row.original.id}
                            >
                                {String(row.row.original.id).slice(-12)}
                            </p>
                            <button
                                style={{
                                    padding: "5px",
                                    background: "#5784f5",
                                    color: "#fff",
                                    fontSize: "14px",
                                    border: "none",
                                    outline: "none",
                                    borderRadius: "10px",
                                    cursor: "pointer",
                                }}
                                onClick={(e) => {
                                    let isCopy = copy(String(row.row.original.id).slice(-12));
                                    if (isCopy) {
                                        toast.success("Copied to Clipboard");
                                    }
                                }}
                            >
                                <i class="fa fa-clone"></i>
                            </button>
                        </>
                    );
                },
            },
            {
                Header: "Wallet Id",
                accessor: "",

                Cell: (row) => {
                    return (
                        <>
                            <p
                                data-tooltip-id="my-tooltip"
                                data-tooltip-content={row.row.original.wallet_id}
                            >
                                {row.row.original.wallet_id == null
                                    ? "--"
                                    : row.row.original.wallet_id}
                            </p>
                            {/* <button
                style={{
                  padding: "5px",
                  background: "#5784f5",
                  color: "#fff",
                  fontSize: "14px",
                  border: "none",
                  outline: "none",
                  borderRadius: "10px",
                  cursor: "pointer",
                }}
                onClick={(e) => {
                  let isCopy = copy(row.row.original.wallet_id);
                  if (isCopy) {
                    toast.success("Copied to Clipboard");
                  }
                }}
              >
                <i class="fa fa-clone"></i>
              </button> */}
                        </>
                    );
                },
            },

            {
                Header: "Created date",
                accessor: "",

                Cell: (row) => {
                    const dateString = row.row.original.created_date;
                    const dateObject = new Date(dateString);

                    const hours = dateObject.getHours();
                    const minutes = dateObject.getMinutes();
                    const seconds = dateObject.getSeconds();
                    const amOrPm = hours >= 12 ? "PM" : "AM";
                    const twelveHourFormat = hours % 12 || 12; // 0 should be converted to 12

                    const formattedTime = `${twelveHourFormat}:${minutes} ${amOrPm}`;

                    return (
                        <>
                            <p
                                data-tooltip-id="my-tooltip"
                                data-tooltip-content={`${formattedTime}`}
                            >
                                {`${row.row.original.created_date.slice(0, 10) +
                                    "  " +
                                    formattedTime
                                    }`}
                            </p>
                        </>
                    );
                },
            },

            {
                Header: "Patient Name",
                accessor: "",
                Cell: (row) => {
                    return (
                        <>
                            <p
                                data-tooltip-id="my-tooltip"
                                data-tooltip-content={
                                    row.row.original.patient.first_name +
                                    row.row.original.patient.last_name
                                }
                            >
                                {row.row.original.patient.first_name + " " +
                                    row.row.original.patient.last_name}
                            </p>
                        </>
                    );
                },
            },
            {
                Header: "Patient Ph.No",
                accessor: "",

                Cell: (row) => {
                    return (
                        <>
                            <p
                                data-tooltip-id="my-tooltip"
                                data-tooltip-content={row.row.original.patient.phonenumber}
                            >
                                {String(row.row.original.patient.phonenumber)}
                            </p>
                        </>
                    );
                },
            },
            {
                Header: "UHID",
                accessor: "",
                Cell: (row) => {
                    return (
                        <>
                            <p
                                data-tooltip-id="my-tooltip"
                                data-tooltip-content={row.row.original.patient.p_uhid}
                            >
                                {row.row.original.patient.p_uhid}
                            </p>
                        </>
                    );
                },
            },

            {
                Header: "Initial Wallet ",
                accessor: "",
                Cell: (row) => {
                    return (
                        <>
                            <p
                                data-tooltip-id="my-tooltip"
                                data-tooltip-content={row.row.original.previous_cashbackpoints}
                            >
                                <span id="prefix">₹</span>
                                {row.row.original.previous_cashbackpoints == null
                                    ? "0"
                                    : parseFloat(
                                        row.row.original.previous_cashbackpoints
                                    ).toFixed(2)}
                            </p>
                        </>
                    );
                },
            },
            {
                Header: "Wallet amount Used",
                accessor: "",
                Cell: (row) => {
                    return (
                        <>
                            <p
                                data-tooltip-id="my-tooltip"
                                data-tooltip-content={row.row.original.used_cashbackpoints}
                            >
                                <span id="prefix">₹</span>
                                {row.row.original.used_cashbackpoints == null
                                    ? "0"
                                    : parseFloat(row.row.original.used_cashbackpoints).toFixed(2)}
                            </p>
                        </>
                    );
                },
            },
            {
                Header: "Assigned By",
                accessor: "",
                Cell: (row) => {
                    return (
                        <>
                            <p
                                data-tooltip-id="my-tooltip"
                                data-tooltip-content={
                                    row.row.original.assigned_by == null
                                        ? "--"
                                        : row.row.original.assigned_by
                                }
                            >
                                {row.row.original.assigned_by == null
                                    ? "--"
                                    : row.row.original.assigned_by}
                            </p>
                        </>
                    );
                },
            },
            {
                Header: "Assigned To",
                accessor: "",
                Cell: (row) => {
                    return (
                        <>
                            <p
                                data-tooltip-id="my-tooltip"
                                data-tooltip-content={
                                    row.row.original.assigned_to == null
                                        ? "--"
                                        : row.row.original.assigned_to
                                }
                            >
                                {row.row.original.assigned_to == null
                                    ? "--"
                                    : row.row.original.assigned_to}
                            </p>
                        </>
                    );
                },
            },
            {
                Header: "Delivery Ph.No",
                accessor: "",

                Cell: (row) => {
                    return (
                        <>
                            <p
                                data-tooltip-id="my-tooltip"
                                data-tooltip-content={row.row.original.phone_number}
                            >
                                {String(row.row.original.phone_number)}
                            </p>
                        </>
                    );
                },
            },
            {
                Header: "Status",
                accessor: "",
                Cell: (row) => {
                    let data = row.row.original.status;
                    return (
                        <>
                            <p
                                data-tooltip-id="my-tooltip"
                                className={
                                    data == "Confirming order"
                                        ? "ordered"
                                        : data == "Confirm the details"
                                            ? "confirm"
                                            : data == "En route"
                                                ? "enroute"
                                                : data == "Samples Collected"
                                                    ? "done"
                                                    : ""
                                }
                                data-tooltip-content={data}
                            >
                                {data}
                            </p>
                        </>
                    );
                },
            },
            {
                Header: "Total Amount",
                accessor: "",
                Cell: (row) => {
                    return (
                        <>
                            <p
                                data-tooltip-id="my-tooltip"
                                data-tooltip-content={row.row.original.total_amount}
                            >
                                {parseFloat(row.row.original.total_amount).toFixed(2)}
                            </p>
                        </>
                    );
                },
            },
            {
                Header: "Paid",
                accessor: "",
                Cell: (row) => {
                    return (
                        <>
                            {row.row.original.razorpay_diagnostics != null ? (
                                <p
                                    data-tooltip-id="my-tooltip"
                                    data-tooltip-content={
                                        row.row.original.razorpay_diagnostics.isPaid == false
                                            ? "No"
                                            : "Yes"
                                    }
                                >
                                    {row.row.original.razorpay_diagnostics.isPaid == false ? (
                                        <p style={{ color: "red", fontWeight: 700 }}>No</p>
                                    ) : (
                                        <p style={{ color: "green", fontWeight: 700 }}>Yes</p>
                                    )}
                                </p>
                            ) : row.row.original.fully_used == false ? (
                                <p style={{ color: "red", fontWeight: 700 }}>No</p>
                            ) : (
                                <p style={{ color: "green", fontWeight: 700 }}>Yes</p>
                            )}
                        </>
                    );
                },
            },

            {
                Header: "Location Range",
                accessor: "",
                Cell: (row) => {
                    return (
                        <>
                            <p
                                data-tooltip-id="my-tooltip"
                                data-tooltip-content={
                                    row.row.original.address.location_range == null
                                        ? ""
                                        : row.row.original.address.location_range
                                }
                            >
                                {row.row.original.address.location_range != null
                                    ? row.row.original.address.location_range + " Km"
                                    : "--"}
                            </p>
                        </>
                    );
                },
            },
            {
                Header: "Patient Address",
                accessor: "",
                Cell: (row) => {
                    return (
                        <>
                            <p
                                data-tooltip-id="my-tooltip"
                                data-tooltip-content={
                                    row.row.original.address.location_range == null
                                        ? ""
                                        : row.row.original.address.location_range
                                }
                            >
                                Copy address
                                {/* <b>Address: </b> <br />
                {row.row.original.address.address_line1}
                <br />
                {row.row.original.address.address_line2}
                <br />
                {row.row.original.address.pincode_p}
                <br /> */}
                            </p>
                            <button
                                style={{
                                    padding: "5px",
                                    background: "#5784f5",
                                    color: "#fff",
                                    fontSize: "14px",
                                    border: "none",
                                    outline: "none",
                                    borderRadius: "10px",
                                    cursor: "pointer",
                                }}
                                onClick={(e) => {
                                    let string_convert = String(
                                        row.row.original.address.address_line1 +
                                        ", " +
                                        row.row.original.address.address_line2 +
                                        ", Latitude: " +
                                        row.row.original.address.latitude +
                                        ", Longitude: " +
                                        row.row.original.address.longitude
                                    );
                                    let isCopy = copy(string_convert);
                                    if (isCopy) {
                                        toast.success("Copied to Clipboard");
                                    }
                                }}
                            >
                                <i class="fa fa-clone"></i>
                            </button>
                        </>
                    );
                },
            },
            {
                Header: "Razor pay ID",
                accessor: "",
                Cell: (row) => {
                    return (
                        <>
                            <span>
                                <div
                                    style={{ marginTop: "3px" }}
                                    data-tooltip-id="appoinment"
                                    data-tooltip-content={String(
                                        row.row.original?.razorpay_diagnostics?.diagnostic_order_id
                                    )}
                                >
                                    {row.row.original?.razorpay_diagnostics?.diagnostic_order_id ==
                                        null
                                        ? "--"
                                        : row.row.original?.razorpay_diagnostics?.diagnostic_order_id}
                                </div>
                            </span>
                        </>
                    );
                },
            },
            {
                Header: "VisitDate",
                accessor: "",
                Cell: (row) => {
                    return (
                        <>
                            <span>
                                <div
                                    style={{ marginTop: "3px" }}
                                    data-tooltip-id="appoinment"
                                    data-tooltip-content={String(row.row.original.visit_date)}
                                >
                                    {String(row.row.original.visit_date)}
                                </div>
                            </span>
                        </>
                    );
                },
            },
            {
                Header: "VisitTime",
                accessor: "",
                Cell: (row) => {
                    return (
                        <>
                            <span>
                                <div
                                    style={{ marginTop: "3px" }}
                                    data-tooltip-id="appoinment"
                                    data-tooltip-content={String(row.row.original.visit_slot)}
                                >
                                    {String(row.row.original.visit_slot)}
                                </div>
                            </span>
                        </>
                    );
                },
            },
            // {
            //     Header: "Actions",
            //     accessor: "",
            //     Cell: (row) => {
            //         // console.log(row.row.original)
            //         //settablevalue(row.row.original)

            //         return (
            //             <>
            //                 <div class="actions">
            //                     <button
            //                         type="button"
            //                         class="btn btn-danger btn-sm delete"
            //                         onClick={(e) => {
            //                             deleteappoinment(row.row.original.id, row.row.original);
            //                         }}
            //                         // disabled={row.row.original.appointment.status == 0?false:true}
            //                         disabled={row.row.original.request_status == false ? true : false}
            //                     >
            //                         <i class="bi bi-trash3"></i> Return
            //                     </button>
            //                 </div>
            //             </>
            //         );
            //     },
            // },
        ],
        []
    );
    const pagesize = (arg) => {
        setdtPagesize(arg);
    };

    const pageindex = (arg) => {
        setdtPageindex(arg);
    };
    const handleSubmit = (event) => {
        event.preventDefault();
    };

    const datadownload = () => {
        Swal.fire({
            title: 'Are you sure?',
            text: "Do You Want To Download The Data?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes'
        }).then((result) => {
            if (result.isConfirmed) {
                setdatadownload("True")
            }
            else {
                setdatadownload("False")

            }
        })
    }

    return (
        <>
            <div className={sideactive ? "dashboard-main-sa" : "dashboard-main"}>
                <div class="page-header">
                    <div class="row">
                        <div class="col-sm-7 col-auto">
                            <h3 class="page-title">Diagnostics Records</h3>
                            <ul class="breadcrumb">
                                <li class="breadcrumb-item">
                                    <NavLink
                                        style={{ textDecoration: "none", color: "#333333" }}
                                        to={"/"}
                                        onClick={(e) => {
                                            dispatch(sidebar("DashBoard"));
                                        }}
                                    >
                                        Dashboard
                                    </NavLink>
                                </li>
                                <li class="breadcrumb-item active">Diagnostics Records</li>
                            </ul>
                        </div>
                        <div class="col-sm-5 col-auto">
                            {" "}
                            <div className="datepicker_dash">
                                <DateRangePicker
                                    defaultValue={[
                                        // new Date(new Date().setDate(today.getDate() - 30)),
                                        new Date(),
                                        new Date(),
                                    ]}
                                    // disabledDate={(date) => isAfter(date, new Date())}
                                    editable={false}
                                    appearance="default"
                                    placement="bottomEnd"
                                    size="lg"
                                    ranges={predefinedBottomRanges}
                                    placeholder="From - To"
                                    style={{ width: 270, padding: 10, float: "right" }}
                                    onClean={(e) => cleaningrange(e)}
                                    onChange={(e) => {
                                        if (e != null) {
                                            setrange([]);
                                            e.forEach((newValue) => {
                                                var tzoffset = new Date().getTimezoneOffset() * 60000; //offset in milliseconds
                                                var localISOTime = new Date(newValue - tzoffset)
                                                    .toISOString()
                                                    .slice(0, -1);
                                                handlechangedate("validtill", localISOTime);
                                            });
                                        }
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-12">
                    <div className="card">
                        <div className="card-body" style={{ padding: "1.5rem" }}>

                            <div align="center" type="button" style={{
                                display: "flex", justifyContent: "flex-end"
                            }} >
                                <a class="dnbtn" onClick={(e) => {
                                    datadownload();
                                }}></a>
                            </div>
                            <div className="row pt-4">
                                <div className="col-xl-4 col-sm-6 col-12 ">
                                    <div class="card">
                                        <div class="card-body" style={{ padding: "1.5rem" }}>
                                            <div class="dash-widget-header">
                                                <span class="dash-widget-icon text-primary border-primary">
                                                    <i class="bi bi-cash-coin"></i>
                                                </span>
                                                <div class="dash-count">
                                                    <h3>{doctorcount != NaN ? doctorcount : ""}</h3>
                                                </div>
                                            </div>
                                            <div class="dash-widget-info">
                                                <h6 class="text-muted">Amount Paid</h6>
                                                {/* <div class="progress progress-sm">
                          <div
                            class="progress-bar bg-primary"
                            role="progressbar"
                            style={{ width: `${doctorcount / 10}%` }}
                            aria-valuenow={doctorcount}
                            aria-valuemin="0"
                            aria-valuemax="100%"
                          ></div>
                        </div> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* <div className="col-xl-4 col-sm-6 col-12 ">
                  <div class="card">
                    <div class="card-body" style={{ padding: "1.5rem" }}>
                      <div class="dash-widget-header">
                        <span class="dash-widget-icon text-danger border-danger">
                          <i class="bi bi-person-vcard-fill"></i>
                        </span>
                        <div class="dash-count">
                          <h3>
                            {appoinmentcount != NaN ? appoinmentcount : ""}
                          </h3>
                        </div>
                      </div>
                      <div class="dash-widget-info">
                        <h6 class="text-muted">Appointment</h6>
                        <div class="progress progress-sm">
                          <div
                            class="progress-bar bg-danger"
                            style={{ width: `${appoinmentcount / 10}%` }}
                            aria-valuenow={appoinmentcount}
                            aria-valuemin="0"
                            aria-valuemax="100%"
                          ></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div> */}
                            </div>
                            <form
                                onSubmit={handleSubmit}
                                style={{ display: "flex", justifyContent: "space-between" }}
                            >
                                <div
                                    class="input-group rounded"
                                    style={{ width: "250px", height: "40px" }}
                                >
                                    <input
                                        type="search"
                                        class="form-control rounded"
                                        aria-label="Search"
                                        aria-describedby="search-addon"
                                        value={searchQuery}
                                        onKeyDown={(e) => {
                                            if (e.target.value.length === 0 && e.which === 32) {
                                                e.preventDefault();
                                            }
                                        }}
                                        onInput={(e) => {
                                            if (e.target.value.length <= "100") {
                                                setSearchQuery(e.target.value);
                                            } else {
                                                e.preventDefault();
                                            }
                                        }}
                                        // onKeyDown={(e)=>{if(e.which=="32"){
                                        //   e.preventDefault()
                                        // }}}

                                        min="0"
                                        max="10"
                                        label="Search"
                                        placeholder="Search..."
                                        required
                                    />
                                    <span
                                        class="input-group-text border-0 bg-transparent"
                                        id="search-addon"
                                    >
                                        <i
                                            class="bi bi-search"
                                            style={{
                                                color: "#1b5a90",
                                                width: "20px",
                                                height: "20px",
                                            }}
                                        ></i>
                                    </span>
                                </div>
                                <div style={{ display: "flex", alignItems: "center" }}>
                                    <div style={{ display: "flex", alignItems: "center" }}>
                                        <label class="mr-2">From Age</label>
                                        <input
                                            type="number"
                                            class="form-control mr-2"
                                            style={{ width: "60px" }}
                                            onWheel={(e) => {
                                                document.activeElement.blur();
                                            }}

                                            onKeyDown={(evt) =>
                                                ["e", "E", "+", "-"].includes(evt.key) &&
                                                evt.preventDefault()
                                            }

                                            placeholder="Age"
                                            value={ageit}
                                            onChange={(e) => {
                                                if (e.target.value <= 120) {
                                                    setageit(e.target.value);
                                                }
                                            }}
                                        ></input>
                                    </div>
                                    <div style={{ display: "flex", alignItems: "center" }}>
                                        <label class="mr-2">To Age</label>

                                        <input
                                            type="number"
                                            class="form-control mr-2"
                                            style={{ width: "60px" }}
                                            onWheel={(e) => {
                                                document.activeElement.blur();
                                            }}

                                            onKeyDown={(evt) =>
                                                ["e", "E", "+", "-"].includes(evt.key) &&
                                                evt.preventDefault()
                                            }

                                            placeholder="Age"
                                            value={agegt}
                                            onChange={(e) => {
                                                if (e.target.value <= 120) {
                                                    setagegt(e.target.value);
                                                }
                                            }}
                                        ></input>
                                        <div
                                            class="input-group rounded mr-2"
                                            style={{ width: "250px", height: "40px", display: "flex", alignItems: "center" }}
                                        >
                                            <label class="mr-2">Gender</label>
                                            <select
                                                class="form-select"
                                                value={gender}
                                                name="gender"
                                                onChange={(e) => {
                                                    setgender(e.target.value);
                                                }}
                                            >
                                                <option selected disabled value="">
                                                    Filter By Gender...
                                                </option>
                                                <option value={"all"}>All</option>
                                                <option value={"0"}>Male</option>
                                                <option value={"1"}>Female</option>
                                                <option value={"2"}>Others</option>
                                                <option value={"3"}>Decline to State</option>
                                            </select>
                                        </div>

                                        {/* <div
                      class="input-group rounded mr-2"
                      style={{ width: "250px", height: "40px", display: "flex", alignItems: "center" }}
                    >
                      <label class="mr-2">Branch</label>
                      <select
                        class="form-select"
                        value={branches}
                        name="branch"
                        onChange={(e) => {
                          setbranches(e.target.value);
                        }}
                      >
                        <option selected disabled value="">
                          Filter By Location...
                        </option>
                        <option value={"all"}>All</option>
                        <option value={"0"}>VELACHERY</option>
                        <option value={"1"}>CHETPET</option>
                        <option value={"2"}>KOLATHUR</option>
                      </select>
                    </div> */}
                                    </div>
                                </div>
                            </form>
                            <div className="table-responsive">
                                <BasicTable
                                    columns={columns}
                                    data={tableheaderdata}
                                    pagesize={pagesize}
                                    pageindex={pageindex}
                                    dtpagesize={dtpagesize}
                                    dtpageindex={dtpageindex}
                                    datacount={datacount}
                                    location={"others"}
                                    setbranches={setbranches}
                                    branches={branches}

                                />
                            </div>
                        </div>
                    </div>
                </div>
                <ReactTooltip
                    id="my-tooltip"
                    arrowColor="transparent"
                    place="bottom-start"
                    delayShow={50}
                    style={{
                        backgroundColor: "#707070",
                        fontSize: "10px",
                        textAlign: "center",
                        padding: "5px",
                        fontWeight: 400,
                    }}
                />
            </div>
        </>
    );
}
